export default function({ $auth, store }) {
 	if ($auth.$state.loggedIn === true && store.state.NeedGetData.AccountWallet === true)
 		return store.dispatch('account/GetAccountData')
}